<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="SelectedPerson == undefined || loading == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
			Refresh
		</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="SelectedPerson == undefined || loading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddGuardian()">
			Add Guardian
		</button>
		<button
			[disabled]="SelectedPerson == undefined || loading == true || CanEdit() == false"
			class="btn btn-primary"
			style="margin-left: 5px"
			(click)="onEditGuardian()"
		>
			Edit Guardian
		</button>
		<button
			[disabled]="SelectedPerson == undefined || loading == true || CanEdit() == false"
			class="btn btn-primary"
			style="margin-left: 5px"
			(click)="onDeleteGuardian()"
		>
			Delete Guardian
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGuardian"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGuardian"
		dataKey="Parent_PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Name-->
				<th>
					<p-columnFilter type="text" field="Name" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Relationship-->
				<th>
					<p-columnFilter field="Relationship" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterRelationship
								[ngModel]="value"
								[options]="lstRelationship"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StreetAddress-->
				<th>
					<p-columnFilter type="text" field="StreetAddress" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--City-->
				<th>
					<p-columnFilter field="City" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCity
								[ngModel]="value"
								[options]="lstCity"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--State-->
				<th>
					<p-columnFilter field="State" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterState
								[ngModel]="value"
								[options]="lstState"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Zip-->
				<th>
					<p-columnFilter field="Zip" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterZip [ngModel]="value" [options]="lstZip" (onChange)="filter($event.value)" placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HomePhone-->
				<th>
					<p-columnFilter type="text" field="HomePhone" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--WorkPhone-->
				<th>
					<p-columnFilter type="text" field="WorkPhone" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--CellPhone-->
				<th>
					<p-columnFilter type="text" field="CellPhone" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="EMail" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--HomeLanguage-->
				<th>
					<p-columnFilter field="HomeLanguage" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHomeLanguage
								[ngModel]="value"
								[options]="lstHomeLanguage"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="Name">Name<p-sortIcon field="Name"></p-sortIcon></th>
				<th pSortableColumn="Relationship">Relationship<p-sortIcon field="Relationship"></p-sortIcon></th>
				<th pSortableColumn="StreetAddress">Address<p-sortIcon field="StreetAddress"></p-sortIcon></th>
				<th pSortableColumn="City">City<p-sortIcon field="City"></p-sortIcon></th>
				<th pSortableColumn="State">State<p-sortIcon field="State"></p-sortIcon></th>
				<th pSortableColumn="Zip">Zip<p-sortIcon field="Zip"></p-sortIcon></th>
				<th pSortableColumn="HomePhone">Home Phone<p-sortIcon field="HomePhone"></p-sortIcon></th>
				<th pSortableColumn="WorkPhone">Work Phone<p-sortIcon field="WorkPhone"></p-sortIcon></th>
				<th pSortableColumn="CellPhone">Cell Phone<p-sortIcon field="CellPhone"></p-sortIcon></th>
				<th pSortableColumn="EMail">E-Mail<p-sortIcon field="EMail"></p-sortIcon></th>
				<th pSortableColumn="HomeLanguage">Home Language<p-sortIcon field="HomeLanguage"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Guardian>
			<tr [pSelectableRow]="Guardian" (dblclick)="onRowDblClick(Guardian)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Guardian[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
